import React from 'react';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

export const CollectBusinessInfoPlaceholderStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.COLLECT_BUSINESS_INFO,
  render: () => <></>,
};
